import { useQuery } from "@tanstack/react-query";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../../utils/utils";
import { PatientPaymentControllerApi } from "../../../services";

/**
 *
 * @author Atish Bagate
 */
interface GetPatientPaymentByIdProps {
  patientPaymentId: string;
}

export function useGetPatientPaymentById({
  patientPaymentId,
}: GetPatientPaymentByIdProps): useBaseContent<any> {
  return useQuery({
    queryKey: ["Get-patient-payment-by-id", patientPaymentId],
    enabled: !!patientPaymentId,
    queryFn: async () =>
      new PatientPaymentControllerApi(getConfigObject())
        .getPatientPaymentById(patientPaymentId, getXtenantId())
        .then((it) => it?.data),
  });
}
